/**
 * This service handle email itinerary such get provider and send email intinerary
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { StorageService } from '@app/services/storage.service';

import { EmailItinerary } from '../interfaces/emailitinerary';

@Injectable({
  providedIn: 'root'
})
export class EmailItineraryService {
  private headerOptions;
  private headers;

  constructor(
    private storageService: StorageService,
    private http: HttpClient) {
    this.headers = new HttpHeaders();
    this.headers.append('Content-Type', 'application/json');
    this.headerOptions = { headers: this.headers,
    observe: 'body'};
  }

  /**
   * get provider list
   * @param mobileNumber e.g +61491570156
   */
  getProviders(mobileNumber, deviceUUID, pin, env?) {
    const ENV = this.storageService.ENV || env;

    return this.http.get<any>(`${environment.apiHostUrls[ENV]}/itineraryProvider`, {
      params: {
        deviceUUID,
        pin,
        mobileNumber
      },
      headers: this.headers
    });
  }

  /**
   * submit email itinerary
   * @param postData <EmailItinerary>
   */
  submitEmailItinerary(postData: EmailItinerary) {
    const ENV = this.storageService.ENV;
    this.headerOptions.responseType = 'json';
    return this.http.post<any>(`${environment.apiHostUrls[ENV]}/emailItinerary`, postData, this.headerOptions);
  }
}
